/* Sail Workshop — çerçevesiz seçenekte rengi sıfırla
   Yakalama (capture) aşamasında çalışır: Dawn'ın kendi işleyicisinden ÖNCE
   rengi düzeltir, böylece tek sunucu isteği yapılır ve gecikme oluşmaz.
   document üzerine bağlıdır; bölüm yeniden çizilse de kaybolmaz. */
(function () {
  var FRAMELESS = ['poster', 'rolled', 'gallery wrap'];

  function isFrameless(v) {
    v = (v || '').toLowerCase();
    return FRAMELESS.some(function (w) { return v.indexOf(w) > -1; });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.value) return;

    var field = input.closest('fieldset, .product-form__input');
    if (!field || field.classList.contains('sw-color-pills')) return;
    var t = input.getAttribute('data-sw-type');
    if (t ? (t !== 'PRC' && t !== 'GAL') : !isFrameless(input.value)) return;

    var root = input.closest('variant-selects');
    if (!root) return;
    var colors = root.querySelector('.sw-color-pills');
    if (!colors) return;

    var current = colors.querySelector('input[type="radio"]:checked');
    var first = colors.querySelector('input[type="radio"]:not(.disabled):not([disabled])')
             || colors.querySelector('input[type="radio"]');
    if (first && current && first !== current) {
      current.checked = false;
      first.checked = true;      // olay tetiklemiyoruz — Dawn formu okurken düzeltilmiş değeri görür
    }
  }, true);                      // true = yakalama aşaması
})();
